// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 997) return "static/chunks/997-65b5ba095279f71b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"0":"a1c8b1a23116ce66","545":"23014b3cfcefe5f7","929":"c4c3b9ca5f8901cc"}[chunkId] + ".js";
};